export const MAX_ID_DOCUMENT_VERIFICATION_ATTEMPTS = 2
